import {
  AfterViewInit,
  Directive,
  ElementRef,
  input,
  model,
  OnInit,
  inject,
} from '@angular/core';
import {
  combineLatest,
  delay,
  distinct,
  filter,
  first,
  Subject,
  switchMap,
} from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { UnsubscribeBase } from '../base';

@Directive({
  selector: '[coreScrollTo]',
  standalone: true,
})
export class ScrollToDirective
  extends UnsubscribeBase
  implements OnInit, AfterViewInit
{
  private el = inject(ElementRef);
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  fragment = model<string>('', { alias: 'coreScrollTo' });
  isScroll = model<boolean>(false);
  delayMS = input<number>(0);
  private doScrollStream$ = new Subject();

  ngOnInit() {
    this.addSubscription = combineLatest([
      this.route.queryParams,
      this.route.fragment,
    ])
      .pipe(
        switchMap(([params, fragment]) => {
          this.isScroll.set(!!params['scroll']);
          if (fragment === this.fragment()) {
            return this.doScrollStream$.pipe(
              distinct(),
              filter(Boolean),
              delay(this.delayMS()),
              first(),
            );
          }
          return [];
        }),
      )
      .subscribe(() => {
        this.directScroll();
        this.removeScrollQueryParam();
      });
  }

  ngAfterViewInit() {
    this.doScroll();
  }

  private directScroll() {
    this.el.nativeElement.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  }

  private doScroll() {
    this.doScrollStream$.next(this.isScroll());
  }

  private removeScrollQueryParam() {
    const urlTree = this.router.parseUrl(this.router.url);
    if (urlTree.queryParams['scroll']) {
      delete urlTree.queryParams['scroll'];
      this.router
        .navigateByUrl(
          this.router.createUrlTree([], { queryParams: urlTree.queryParams }),
        )
        .then();
    }
  }
}
